import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
})

/**
 * 使用 Supabase Auth token 设置 session
 * 在 admin 登录成功后调用，让 supabase client 能直接查表
 */
export async function setSupabaseSession(accessToken: string, refreshToken: string) {
  try {
    await supabase.auth.setSession({
      access_token: accessToken,
      refresh_token: refreshToken,
    })
  } catch (error) {
    console.error('Failed to set supabase session:', error)
  }
}

/**
 * 初始化时恢复 session
 */
export async function restoreSupabaseSession() {
  const accessToken = localStorage.getItem('supabase_access_token')
  const refreshToken = localStorage.getItem('supabase_refresh_token')
  if (accessToken && refreshToken) {
    await setSupabaseSession(accessToken, refreshToken)
  }
}
